import { useEffect } from 'react';
import { DateRangeOption } from '../enum/DatePicker';
import { DateTimeRange } from '../interface/data-picker/DataPicker';

/**
 * Hook that automatically detects and sets the selectedDateOption
 * whenever the range (from/to) changes.
 */
export const useSyncSelectedDateOption = (
  range: DateTimeRange,
  detectDateOption: (from?: Date, to?: Date) => DateRangeOption,
  setSelectedDateOption: (option: DateRangeOption) => void,
) => {
  useEffect(() => {
    const option = detectDateOption(
      range.from ? new Date(range.from) : undefined,
      range.to ? new Date(range.to) : undefined,
    );
    setSelectedDateOption(option);
  }, [range.from, range.to, detectDateOption, setSelectedDateOption]);
};
